import { styled } from '@mui/material';

export const DebugContainer = styled('pre')`
  background-color: #4b0345;
  color: white;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1;
  text-align: left;
`;
